import React from "react";
import styled from "styled-components";
import FilterRuleEditButton from "components/streams/StreamDetails/output-filter/FilterRuleEditButton";
import FilterDeleteButton from "components/streams/StreamDetails/output-filter/FilterDeleteButton";
const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
const FilterActions = ({ filterRule, destinationType }) => /* @__PURE__ */ React.createElement(ActionWrapper, null, /* @__PURE__ */ React.createElement(FilterRuleEditButton, { filterRule, destinationType, streamId: filterRule.stream_id }), /* @__PURE__ */ React.createElement(FilterDeleteButton, { streamId: filterRule.stream_id, filterOutputRule: filterRule }));
export default FilterActions;
